import React from 'react';
import RecommendStoreSaveNavbar from '../RecommendStoreSaveNavbar';
import RecommendStoreSaveInfo from '../RecommendStoreSaveInfo';
import RecommendStoreSaveItemList from '../RecommendStoreSaveItemList';
import './RecommendStoreSaveWrap.scss';
import { RECOMMEND_STORE_TYPE } from '../../../../../constants/service/app/recommendStoreConstants';

const RecommendStoreSaveWrap = (props) => {
  const {
    form,
    recommendStoreSave,
    setData,
    getRecommendStoreItemList,
    selectRecommendStoreItemList,
    onSubmit,
    onDragEndSelectRecommendStoreItemList,
    getRecommendStoreItemListExcelDownload,
    getSelectedRecommendStoreItemListExcelDownload,
    setRecommendStoreItemListExcelUpload,
    typeDisabled,
  } = props;
  const { recommendStoreInfo, recommendStoreItemList } = recommendStoreSave;

  return (
    <div className="recommend-store-copy-wrap">
      {/* 하단 네브바 */}
      <RecommendStoreSaveNavbar onSubmit={onSubmit} />

      {/* 추천 상품 후기 정보 */}
      <RecommendStoreSaveInfo
        form={form}
        setData={setData}
        resetSubText={() =>
          setData({
            path: ['recommendStoreSave', 'recommendStoreItemList', 'selectedItemList', 'list'],
            value: recommendStoreItemList.selectedItemList.list.map((item) => ({
              ...item,
              subText: null,
            })),
          })
        }
        recommendStoreInfo={recommendStoreInfo}
        typeDisabled={typeDisabled}
      />

      {/* 추천 상품 후기 아이템 리스트*/}
      <RecommendStoreSaveItemList
        form={form}
        setData={setData}
        showSubText={recommendStoreInfo.type === RECOMMEND_STORE_TYPE.PRODUCT_FILTER_RECOMMEND}
        recommendStoreItemList={recommendStoreItemList}
        getRecommendStoreItemList={getRecommendStoreItemList}
        selectRecommendStoreItemList={selectRecommendStoreItemList}
        onDragEndSelectRecommendStoreItemList={onDragEndSelectRecommendStoreItemList}
        getRecommendStoreItemListExcelDownload={getRecommendStoreItemListExcelDownload}
        getSelectedRecommendStoreItemListExcelDownload={getSelectedRecommendStoreItemListExcelDownload}
        setRecommendStoreItemListExcelUpload={setRecommendStoreItemListExcelUpload}
      />
    </div>
  );
};

export default RecommendStoreSaveWrap;
